interface AnalyticsEvent extends CustomEvent {
  detail: {
    [key: string]: any;
  };
}

export const mountAnalyticsUtilsOnWindow = () => {
  window.populateAnalyticsDataLayer = (eventName, payload = {}) => {
    window['dataLayer'] = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...payload,
    });
  };

  window.DMRStepEventHandler = function (eventName) {
    document.dispatchEvent(
      new CustomEvent('GTM-EVENT:DMRSTEP', {
        bubbles: true,
        detail: {
          eventName: eventName,
        },
      })
    );
  };
};

export const mountAnalyticsEventListeners = () => {
  document.addEventListener(
    'GTM-EVENT:onInvitationAccept',
    (event: AnalyticsEvent) => {
      const {
        email,
        phone,
        investment_amount,
        name = ' ',
        user_id,
      } = event.detail;
      const [firstName, lastName] = name.split(' ');
      const investment_start = new Date().toISOString();
      // for type consistency with how it's set in default site tag
      const userIdString = user_id ? user_id.toString() : undefined;

      const payload = {
        investment_amount,
        email,
        phone,
        firstname: firstName,
        lastname: lastName,
        investment_start,
        user_id: userIdString,
      };

      window.populateAnalyticsDataLayer('investment_process', payload);
    }
  );

  document.addEventListener('GTM-EVENT:DMRSTEP', (event: AnalyticsEvent) => {
    const payload = event.detail;

    window.populateAnalyticsDataLayer(payload.eventName);
  });

  document.addEventListener(
    'GTM-EVENT:engageClick',
    (event: AnalyticsEvent) => {
      const {label, engageClick, companyId, dmAdmin} = event.detail;
      const engageClickValue = engageClick.trim().slice(0, 20).trim();
      const dmAdminValue = dmAdmin || false;

      if (engageClickValue)
        window.populateAnalyticsDataLayer('engageClick', {
          label,
          engageClick: engageClickValue,
          companyId,
          dmAdmin: dmAdminValue,
        });
    }
  );

  document.addEventListener('GTM-EVENT:funded', (event: AnalyticsEvent) => {
    const {first_name, last_name, email, zip_code, phone, subtotal_amount} =
      event.detail;

    window.populateAnalyticsDataLayer('funded', {
      first_name,
      last_name,
      email,
      zip_code,
      phone,
      subtotal_amount,
    });
  });

  document.addEventListener(
    'GTM-EVENT:onReservationStart',
    (event: AnalyticsEvent) => {
      const {email, phone} = event.detail;

      const payload = {
        email,
        phone,
      };

      window.populateAnalyticsDataLayer('reservation_start', payload);
    }
  );

  document.addEventListener(
    'GTM-EVENT:onReservationAmountSet',
    (event: AnalyticsEvent) => {
      const {email, phone, amount} = event.detail;

      const payload = {
        email,
        phone,
        amount,
      };

      window.populateAnalyticsDataLayer('reservation_amount', payload);
    }
  );

  document.addEventListener(
    'GTM-EVENT:onReservationComplete',
    (event: AnalyticsEvent) => {
      const {
        email,
        phone,
        amount,
        first_name,
        last_name,
        city,
        state,
        zip_code,
      } = event.detail;

      const payload = {
        email,
        phone,
        amount,
        first_name,
        last_name,
        city,
        state,
        zip_code,
      };

      window.populateAnalyticsDataLayer('reservation_complete', payload);
    }
  );

  document.addEventListener('GTM-EVENT:signed', (event: AnalyticsEvent) => {
    const {
      investor_id,
      first_name,
      last_name,
      email,
      zip_code,
      phone,
      subtotal_amount,
    } = event.detail;

    window.populateAnalyticsDataLayer('signed', {
      investor_id,
      first_name,
      last_name,
      email,
      zip_code,
      phone,
      subtotal_amount,
    });
  });

  document.addEventListener(
    'GTM-EVENT:onFinishInvitationPageV2',
    (event: AnalyticsEvent) => {
      const {first_name, last_name, email, phone, subtotal_amount, user_id} =
        event.detail;
      // for type consistency with how it's set in default site tag
      const userIdString = user_id ? user_id.toString() : undefined;

      window.populateAnalyticsDataLayer('TOFU', {
        first_name,
        last_name,
        email,
        phone,
        subtotal_amount,
        user_id: userIdString,
      });
    }
  );

  document.addEventListener('GTM-EVENT:traffic', (event: AnalyticsEvent) => {
    const {dealUuid} = event.detail;

    window.populateAnalyticsDataLayer('traffic', {dealUuid});
  });

  document.addEventListener('GTM-EVENT:ttw', (event: AnalyticsEvent) => {
    const {campaignId} = event.detail;

    window.populateAnalyticsDataLayer('ttw', {campaignId});
  });

  document.addEventListener(
    'GTM-EVENT:INVESTOR_PROFILE',
    (event: AnalyticsEvent) => {
      const {
        userId,
        firstName,
        lastName,
        email,
        phone,
        zipCode,
        country,
        subTotalAmount,
      } = event.detail;

      window.populateAnalyticsDataLayer('investor_profile', {
        userId,
        firstName,
        lastName,
        email,
        phone,
        zipCode,
        country,
        subTotalAmount,
      });
    }
  );
};
